<section class="content head">
  <div class="content-wrapper evidence-list">
    <iaud-breadcrumb class="evidence-list--breadcrumbs" [breadcrumbList]="breadcrumbs" *ngIf="sid"></iaud-breadcrumb>
    <iaud-sid-stepper [status]="sid?.status" class="evidence-list--sid-step" *ngIf="sid"></iaud-sid-stepper>
    <div class="evidence-list--top">
        <h1>Evidence Submission</h1>
      <p>Feel free to manage the Evidence list and submit evidences</p>
    </div>
    <div class="evidence-list--top-buttons">
      <button mat-raised-button class="right-margin" [routerLink]="['/audit',auditId,'finding',findingId]" *ngIf="audit">Finish Later</button>
      <button mat-raised-button class="right-margin" [routerLink]="['/sid',sidId]" *ngIf="sid">Finish Later</button>
      <button mat-raised-button class="right-margin" [color]="'accent'" (click)="submitEvidence()" [disabled]="!capa?.canSubmitEvidence">Submit</button>
    </div>
  
    <mat-accordion multi="true" class="evidence-list--parents">
      <iaud-audit-detail-expansion [audit]="audit" class="evidence-list__audit"></iaud-audit-detail-expansion>
      <iaud-finding-detail-expansion [finding]="finding" class="evidence-list__finding"></iaud-finding-detail-expansion>
      <iaud-capa-detail-expansion [capa]="capa" class="evidence-list__capa"></iaud-capa-detail-expansion>
    </mat-accordion>

    <iaud-activity-history-expansion [capaId]="capaId" class="evidence-list--activity"></iaud-activity-history-expansion>

    <h2 class="evidence-list__header" *ngIf="findingId">Evidence List</h2>
    <div class="evidence-list__buttons" *ngIf="!IsApproved">
      <button mat-raised-button class="right-margin" [color]="'accent'" (click)="addEvidence()" 
      *ngIf="capa?.status === (capaStatus.PENDING_FOR_EVIDENCE && canAddEvidence) || (capaStatus.RETURNED && canAddEvidence)">+ Add Evidence</button>      
    </div>

    <div class="evidence-list__buttons" *ngIf="hasHistory">      
      <button mat-raised-button class="right-margin" [color]="'accent'" (click)="showHistory()">Evidence History</button>
    </div>

    <mat-card class="evidence-list__panel" *ngIf="!(evidenceTableData?.totalCount)">
      <div class="evidence-list__no-evidences">
        <div class="evidence-list__no-evidences--icon">
          +
        </div>
        <div class="evidence-list__no-evidences--text">
          <h1>No evidences</h1>
          <p>There are no evidences</p>
          <p *ngIf="capa?.status === (capaStatus.PENDING_FOR_EVIDENCE && canAddEvidence) || (capaStatus.RETURNED && canAddEvidence)">Please add new evidence</p>
        </div>
        <button mat-raised-button class="evidence-list__no-evidences--add-button" [color]="'accent'"
          (click)="addEvidence()" *ngIf="capa?.status === (capaStatus.PENDING_FOR_EVIDENCE && canAddEvidence) || (capaStatus.RETURNED && canAddEvidence)">
          + Add Evidence
        </button>
      </div>
    </mat-card>
  </div>
</section>

<section class="content" *ngIf="evidenceTableData?.totalCount">
  <div class="content-wrapper">
    <iaud-table [data]="evidenceTableData" 
      [options]="evidenceTableOptions" 
      [forceReloadEvent]="forceReloadEvent"
      [dataRefreshCallback]="reloadEvidenceList.bind(this)" 
      [dataDeleteCallback]="deleteData.bind(this)"
      [dataEditCallback]="editEvidence.bind(this)"
      [deleteTitle]="'Delete Evidence'" 
      [deleteText]="'Are you sure you want to delete ${data.evidenceId} evidence?'">
    </iaud-table>
  </div>
</section>

<ng-template #fileCellTemplate let-rowData="rowData">
    <a href="{{evUrl}}/{{rowData.id}}/{{rowData.fileName}}" download>{{rowData.fileName}}</a>
</ng-template>
  